module.exports = __webpack_public_path__ + "img/qrcode.5a9133af.jpeg";